import MapWithSinglePin from "app/pages/MyAppointmentsPage/components/FutureAppointments/MapWithSinglePin";
import React from "react";

const FutureAppointmentMap = () => {
   const state = localStorage.getItem("appointment") || "";
   return <MapWithSinglePin details={JSON.parse(state)} />;
};

export default FutureAppointmentMap;
